// extracted by mini-css-extract-plugin
export default {"button":"OutlineButton_button__SWvWu"};